import React, { Component } from 'react';

class Toast extends Component {
    constructor(props) {
        super(props);
        this.timeoutId = null;
    }

    componentDidMount() {
        if (this.props.show) {
            this.startTimer();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.startTimer();
        } else if (!this.props.show && prevProps.show) {
            this.clearTimer();
        }
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    startTimer = () => {
        this.clearTimer();
        this.timeoutId = setTimeout(() => {
            if (this.props.onClose) {
                this.props.onClose();
            }
        }, 5000); // 5 seconds
    };

    clearTimer = () => {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    };

    handleClose = () => {
        this.clearTimer();
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    render() {
        const { show, type, message } = this.props;

        if (!show || !message) return null;

        const toastClass = type === 'error' ? 'toast-error' : 'toast-success';

        return (
            <div className={`toast-container ${show ? 'toast-show' : ''}`}>
                <div className={`toast-notification ${toastClass}`}>
                    <div className="toast-content">
                        <div className="toast-icon">
                            {type === 'error' ? (
                                <i className="fas fa-exclamation-circle"></i>
                            ) : (
                                <i className="fas fa-check-circle"></i>
                            )}
                        </div>
                        <div className="toast-message">
                            {message}
                        </div>
                        <button 
                            className="toast-close"
                            onClick={this.handleClose}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    <div className="toast-progress">
                        <div className="toast-progress-bar"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Toast;
